import { useState, type FormEvent } from 'react';
import { GRADE_LEVELS, STATES, SUBJECTS, type Course, type GradeLevel, type State, type Subject } from '../../core/course';

export const gradeName = (grade: GradeLevel) => (grade === 'K' ? 'Kindergarten' : `Grade ${grade}`);

/**
 * One state, one grade, one subject for the plan (R3). `initial` may be partial — the shared
 * default prefills only what it has (R6) — and is read only at mount, so it never replaces a
 * field the teacher has touched.
 */
export function CourseForm({ initial, onSubmit, onCancel }: { initial?: Partial<Course> | null; onSubmit(course: Course): void; onCancel?(): void }) {
  const [state, setState] = useState<string>(initial?.state ?? '');
  const [grade, setGrade] = useState<string>(initial?.grade ?? '');
  const [subject, setSubject] = useState<string>(initial?.subject ?? '');
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (state && grade && subject) onSubmit({ state: state as State, grade: grade as GradeLevel, subject: subject as Subject });
  };
  return <form className="setup-form" onSubmit={submit}>
    <div className="profile-grid course-grid">
      <div><label htmlFor="course-state">State</label><select id="course-state" required value={state} onChange={e => setState(e.target.value)}><option value="">Choose your state</option>{STATES.map(s => <option key={s}>{s}</option>)}</select></div>
      <div><label htmlFor="course-grade">Grade</label><select id="course-grade" required value={grade} onChange={e => setGrade(e.target.value)}><option value="">Choose a grade</option>{GRADE_LEVELS.map(g => <option key={g} value={g}>{gradeName(g)}</option>)}</select></div>
      <div><label htmlFor="course-subject">Subject</label><select id="course-subject" required value={subject} onChange={e => setSubject(e.target.value)}><option value="">Choose a subject</option>{SUBJECTS.map(s => <option key={s}>{s}</option>)}</select></div>
    </div>
    <div className="form-footer">
      <button className="primary" type="submit">Continue</button>
      {onCancel && <button className="text-button" type="button" onClick={onCancel}>Cancel</button>}
    </div>
  </form>;
}
